import {Grid, Paper} from "@material-ui/core";
import logo from "../images/inqbay.svg";
import back from "../images/back.png";
import {Link, withRouter} from "react-router-dom";
import menu from "../images/home.png";
import React from "react";
import useStyles from "../components/useStyles";

const Layout = (
    {
        children,
        history,
    }
) => {
    const classes = useStyles();
    const isOnHomepage = history.location.pathname === '/';

    return <>
        <Grid item xs={12}>
            <Paper className={classes.paper1}>
                <img src={logo} className={classes.logoImg}/>
                <br/>
                {
                    isOnHomepage === false && <>
                        <button className={"btn btn--primary--solid"} onClick={() => history.goBack()}>
                            <Grid className={classes.paper}>
                                <img src={back} alt={"Zpět"}/>
                            </Grid>
                        </button>
                        <Link to={'/'}>
                            <button className={"btn btn--primary--solid"}>
                                <Grid className={classes.paper}>
                                    <img src={menu} alt={"Úvod"}/>
                                </Grid>
                            </button>
                        </Link>
                    </>
                }
            </Paper>
        </Grid>
        {children}
    </>;
};

export default withRouter(Layout);
